import { render, staticRenderFns } from "./UsersFeedback.vue?vue&type=template&id=5eb6a25e&"
import script from "./UsersFeedback.vue?vue&type=script&lang=js&"
export * from "./UsersFeedback.vue?vue&type=script&lang=js&"
import style0 from "./UsersFeedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports